import { Button, mediaQueries, style } from '@do/walrus';
import React from 'react';

import styled from 'styled-components';
import { SplashVariant } from '../interfaces/variant';

interface VariantCopyProps {
  color?: string;
  align?: 'center' | 'left';
}

const Wrap = styled.div<VariantCopyProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${({ align }) =>
    align && 'left' === align ? 'start' : 'center'};
  z-index: ${style.vars.zIndex.base};
  text-align: ${({ align }) => (align && 'left' === align ? 'left' : 'center')};
  width: 100%;
  max-width: 720px;
  margin-top: 70px;
  padding: 0 ${style.vars.whitespace.regular};

  ${mediaQueries.medium} {
    margin-top: 115px;
    padding: 0 128px;
  }
`;

const Title = styled.h2<VariantCopyProps>`
  && {
    white-space: pre-line;
    padding: 0;
    margin: ${style.vars.space['3']} 0;
    color: ${({ color }) => (color ? color : 'initial')};
    text-align: center;

    font-size: 1.5rem;

    ${mediaQueries.medium} {
      font-size: 2rem;
    }
  }
`;

const SubTitle = styled.h4<VariantCopyProps>`
  && {
    white-space: pre-line;
    padding: 0;
    margin-top: 0;
    color: ${({ color }) => (color ? color : 'initial')};
    text-align: center;

    font-size: 1rem;

    ${mediaQueries.medium} {
      font-size: 1.125rem;
    }
  }
`;

const SplashButton = styled(Button)`
  margin-top: ${style.vars.space['2']};
  margin-bottom: ${style.vars.space['10']};
`;

const ImgWrapper = styled.img`
  width: 100%;
`;

interface Props {
  variant: SplashVariant;
}

const SplashSplit: React.FC<Props> = ({ variant }) => {
  return (
    <Wrap align={variant.align}>
      {variant.image && (
        <ImgWrapper
          data-testid="variantBackground"
          src={variant.image}
        ></ImgWrapper>
      )}
      {variant.title && (
        <Title color={variant.textColor}>{variant.title}</Title>
      )}
      {variant.subtitle && (
        <SubTitle color={variant.textColor}>{variant.subtitle}</SubTitle>
      )}
      {variant.button && (
        <SplashButton
          variation={variant.button.variation || 'primary'}
          url={variant.button.url}
          fullWidth={variant.button.fullWidth}
          external
        >
          {variant.button.text}
        </SplashButton>
      )}
    </Wrap>
  );
};

export default SplashSplit;
